import { render, staticRenderFns } from "./DevicesStatistics.vue?vue&type=template&id=53aef252&scoped=true"
import script from "./DevicesStatistics.vue?vue&type=script&lang=js"
export * from "./DevicesStatistics.vue?vue&type=script&lang=js"
import style0 from "./DevicesStatistics.vue?vue&type=style&index=0&id=53aef252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aef252",
  null
  
)

export default component.exports